import React, { useContext, useRef } from 'react';
import { ApiContext } from '@api/api';
import { AdminModuleAllNotInheritedPreviewOutDTO, CompanyModuleEnum } from '@api/ringil-api.v2';
import { InputSwitch } from 'primereact/inputswitch';
import { Button } from 'primereact/button';
import useTranslationLgs from '@hooks/i18n/useTranslation.tsx';
import SectionPanel from '@components/framework/panels/SectionPanel.tsx';
import RingilDataTable, { ColumnConfig } from '@components/RingilDataTable/RingilDataTable.tsx';
import SvgBox from '@icons/box.svg?react';

interface ComponentProps {
  customerId: string;
}

const AdminModulesList: React.FC<ComponentProps> = ({ customerId }) => {
  const { adminAllNotInheritedCompanyModules, adminToggleModuleForCompany } = useContext(ApiContext);
  const { tr } = useTranslationLgs();
  const tableRef = useRef<{ reloadData: () => void; selectedObjects: unknown[]; clear: () => void }>(null);

  const toggleModule = (companyModule: CompanyModuleEnum, checked: boolean) => {
    adminToggleModuleForCompany(customerId, { companyModule: companyModule, isActive: checked }, () => {
      tableRef.current?.reloadData();
    });
  };

  const populateData = () => {
    /*adminPopulateCompanyWithDefaultData(matches[2], () => {
      load();
    });*/
    alert('Removed: mysql migration');
  };

  const columnConfig: ColumnConfig<AdminModuleAllNotInheritedPreviewOutDTO>[] = [
    {
      id: 'companyModule',
      header: 'adminCompanyDetail.moduleType',
      headerDefault: 'Module type',
      verticalAlign: 'middle',
      render: row => <div>{row.companyModule}</div>,
    },
    {
      id: 'isActive',
      header: 'adminCompanyDetail.moduleActive',
      headerDefault: 'Active',
      width: '5rem',
      verticalAlign: 'middle',
      render: row => <InputSwitch checked={row.isActive} onChange={e => toggleModule(row.companyModule, e.value)} />,
    },
  ];

  return (
    <SectionPanel
      icon={<SvgBox className={'w-6 h-6'} />}
      iconColor={'var(--content-tertiary)'}
      heading={tr('adminCompanyDetail.ownedModules', 'Owned modules')}
      headerRight={<Button label={tr('adminCompanyDetail.populateWithDefaultData', 'Populate with default data')} onClick={populateData} />}
      dataTestId={'admin-company-section-ownedModules'}>
      <RingilDataTable
        ref={tableRef}
        columnConfig={columnConfig as ColumnConfig<unknown>[]}
        filterName={'admin_company_owned_modules'}
        hidePaginator={true}
        loadDataFromApi={(filter, pageable, onSuccess) =>
          adminAllNotInheritedCompanyModules(customerId, d => onSuccess({ data: d, total: d?.length ?? 0, page: 1, size: d?.length ?? 0 }))
        }
      />
    </SectionPanel>
  );
};

export default AdminModulesList;
